// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2D6Ne","content":"Consent_content__7bOAm","footer":"Consent_footer__3PUi6"};